// src/components/admin/AddThemeForm.js
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api';

const AddThemeForm = ({ projectId, onAdd }) => {
  const { user } = useAuth();
  const [themeName, setThemeName] = useState('');
  const [threshold, setThreshold] = useState(80);
  const [absolutelyEverything, setAbsolutelyEverything] = useState(false);
  const [positive, setPositive] = useState(true); // false = Нет, true = Да
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!themeName.trim()) return;

    try {
      const response = await api.post('/admin/analytics/theme', {
        project_id: projectId,
        name: themeName.trim(),
        threshold: threshold,
        absolutely_everything: absolutelyEverything,
        positive: positive,
      });

      if (response.status === 200 || response.status === 201) {
        setThemeName('');
        setThreshold(80);
        setAbsolutelyEverything(false);
        setPositive(false);
        onAdd(); // Обновить список тем
      }
    } catch (err) {
      console.error('Ошибка при добавлении темы:', err);
      const message = err.response?.data?.message || 'Не удалось добавить тему';
      alert(message);
    }
  };

  if (!roleNames.has('admin')) return null;

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <input type="hidden" name="project_id" value={projectId} />

      {/* Название темы */}
      <div className="input-group mb-3">
        <input
          type="text"
          name="theme_name"
          className="form-control"
          placeholder="Введите название новой темы"
          value={themeName}
          onChange={(e) => setThemeName(e.target.value)}
          required
        />
      </div>

      {/* Порог */}
      <div className="input-group mb-3">
        <label className="input-group-text" htmlFor="theme-threshold">
          Порог (%)
        </label>
        <select
          id="theme-threshold"
          className="form-select"
          value={threshold}
          onChange={(e) => setThreshold(Number(e.target.value))}
        >
          <option value="50">50%</option>
          <option value="60">60%</option>
          <option value="70">70%</option>
          <option value="80">80%</option>
          <option value="90">90%</option>
          <option value="100">100%</option>
        </select>
      </div>

      {/* Тип совпадения */}
      <div className="input-group mb-3">
        <label className="input-group-text" htmlFor="match-type">
          Тип совпадения
        </label>
        <select
          id="match-type"
          className="form-select"
          value={absolutelyEverything}
          onChange={(e) => setAbsolutelyEverything(e.target.value === 'true')}
        >
          <option value="false">Хотя бы одна из фраз</option>
          <option value="true">Обязательно все фразы</option>
        </select>
      </div>

      {/* Позитивность */}
      <div className="input-group mb-3">
        <label className="input-group-text" htmlFor="positive">
          Позитивность
        </label>
        <select
          id="positive"
          className="form-select"
          value={positive}
          onChange={(e) => setPositive(e.target.value === 'true')}
        >
          <option value="true">Да (позитивная)</option>
          <option value="false">Нет (негативная)</option>
        </select>
      </div>

      {/* Кнопка */}
      <button type="submit" className="btn btn-success">
        Добавить тему
      </button>
    </form>
  );
};

export default AddThemeForm;




